import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataHelper } from '@app/helpers/data.helper';
import { ApiService } from '@app/services/api.service';
import { TranslateService } from '@app/services/translate.service';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'bets-accepted-modal',
  templateUrl: '../sharedTemplates/bets-accepted-modal.html',
})
export class BetsAcceptedModal {
  isMobileView = false;

  constructor(
    private _Router: Router,
    public _DataHelper: DataHelper,
    private _ApiService: ApiService,
    public dialogRef: MatDialogRef<BetsAcceptedModal>,
    private _TranslateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _UiHelper: UiHelper
  ) {
    this._UiHelper.closeAllMenus();
    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  slipRestore() {
    this._UiHelper.setLoadingDialog(true);
    try {
      this._ApiService.slipRestore(this.data.slipId).then(x => {
        this._UiHelper.p1001SetBottomDialogState('open');

        if (x) {
          const t_message = this._TranslateService.instant('successcode2');
          this._UiHelper.successSnackBar(t_message, '');
          this._UiHelper.setLoadingDialog(false);

          this.dialogRef.close();
        }
      });
    } catch (error) {
      this._UiHelper.setLoadingDialog(false);
    }
  }

  goMyBets(): void {
    this._Router.navigate(['/account/bet-slip']);
    this.dialogRef.close();
  }
}
